import { AxiosError } from 'axios';

export type globalType = {
  ErrorHandler?: ErrorHandler;
};
/* Error Sources */
export enum ErrorSource {
  LOGIN_AUTH = 'LOGIN_AUTH',
  LOGIN_USER_ACCT = 'LOGIN_USER_ACCT',
  LOGIN_AMBASSADOR_PROFILE = 'LOGIN_AMBASSADOR_PROFILE',
  LOGIN_COMPANY_HOST = 'LOGIN_COMPANY_HOST',
  USER_GET_ACCT = 'USER_GET_ACCT',
  ACCT_GET_NOTIF = 'ACCT_GET_NOTIF',
  ACCT_CHANGE_PASSWORD = 'ACCT_CHANGE_PASSWORD',
  ACCT_SAVE_AMBASSADOR = 'ACCT_SAVE_AMBASSADOR',
  ACCT_SAVE_NOTIFICATIONS = 'ACCT_SAVE_NOTIFICATIONS',
  ACCT_ACTIVATION_STATUS = 'ACCT_ACTIVATION_STATUS',
  CUSTOMER_ADVOCACY_GET_BADGES = 'LOYALTY_GET_BADGES',
  LOYALTY_GET_BADGES = 'LOYALTY_GET_BADGES',
  LOYALTY_GET_TIERS = 'LOYALTY_GET_TIERS',
  LOYALTY_GET_TASKS = 'LOYALTY_GET_TASKS',
  USER_SESSION = 'USER_SESSION',
  USER_REGISTER = 'USER_REGISTER',
  RESET_PASSWORD = 'RESET_PASSWORD',
  REDEEM_REWARD = 'REDEEM_REWARD',
  SAVE_SHARELINK = 'SAVE_SHARELINK',
  W9_TAX_CONTEXT = 'W9_TAX_CONTEXT',
}

/* Error Cause */
export enum ErrorCause {
  API_CALL = 'API_CALL',
  USER_ACTION = 'USER_ACTION',
  CHRON_JOB = 'CHRON_JOB',
}

export class AmbassadorError {
  cause: ErrorCause;
  source: ErrorSource;
  stack: string;
  message: string;
  apiResponse: object;

  constructor(error: Error, source: ErrorSource, cause: ErrorCause, apiResponse: object) {
    this.cause = cause;
    this.source = source;
    //TODO: Identify if its an API Error or Native Axios error to handle the message (ex: timeout error)
    this.message = this.getApiMessage(error as AxiosError);
    this.apiResponse = apiResponse;
    this.stack = new Error().stack?.toString() as string;
  }

  private getApiMessage(e: AxiosError) {
    const errorData = e.response?.data as object;
    const isMultipleError = Object.keys(errorData).length > 1;
    const key = Object?.keys(errorData)[0] as keyof typeof errorData; // casting key type
    const apiResponse: any = errorData[key]; //multiple possible types of response values

    if (typeof apiResponse == 'string') {
      return apiResponse;
    } else if (apiResponse instanceof Array) {
      return apiResponse[0];
    } else {
      return 'No API error was provided.';
    }
  }
}

class ErrorHandler {
  constructor() {
    if ((global as globalType).ErrorHandler) {
      throw new Error('New instance cannot be created.');
    }
    (global as globalType).ErrorHandler = this;
  }
  getInstance() {
    return this;
  }

  get(e: AxiosError, source: ErrorSource, cause: ErrorCause, apiResponse: object): AmbassadorError {
    return new AmbassadorError(e, source, cause, apiResponse);
  }
}

let ErrorHandlerSingleton;
if (!(global as globalType).ErrorHandler) ErrorHandlerSingleton = new ErrorHandler();
else ErrorHandlerSingleton = (global as globalType).ErrorHandler;
export default ErrorHandlerSingleton as ErrorHandler;
